import { IonButton, IonIcon, IonItem, IonLabel, IonSpinner, IonText } from '@ionic/react';
import { refresh } from 'ionicons/icons';
import { useEffect, useState } from 'react';
import { syncTimer } from '../../../common/interval';
import { IDelayCodeSyncStatus } from '../../../models/dms/typecode.model';
import { useDataSync } from '../../../providers/DataSyncProvider';
import { setDelayCodesHasSyncStoreAsync, setDelayCodesSyncLoadingState } from '../../../store/delayCodeSyncSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';

interface IComponentProps {
  title: string;
}

let delayCodesTime: { timestamp: number; sync?: IDelayCodeSyncStatus } = {
  timestamp: 0,
  sync: undefined,
};

const DelayCodesSyncItem: React.FC<IComponentProps> = ({ title }) => {
  const { enableOfflineMode } = useAppSelector((state) => state.settings);
  const {
    state: { delayCodesSyncTimer },
  } = useDataSync();

  const dispatch = useAppDispatch();

  const [delayCodeTimestamp, setDelayCodeTimestamp] = useState(0);
  const { delayCodesSync, delayCodesSyncLoading } = useAppSelector((state) => state.delayCodeSync);

  useEffect(() => {
    const syncSub = syncTimer.subject.subscribe((id) => {
      if (id > 0) {
        const now = new Date().getTime();

        // Repair orders
        if (delayCodesTime.sync) {
          if (delayCodesTime.sync.timestamp <= 0) {
            delayCodesTime.timestamp = -1;
          } else {
            const timeDiff = now - delayCodesTime.sync.timestamp;
            delayCodesTime.timestamp = Math.floor(timeDiff / 60000);
            setDelayCodeTimestamp(delayCodesTime.timestamp);
          }
        }
      }
    });

    return () => syncSub.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    delayCodesTime.sync = delayCodesSync;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delayCodesSync]);

  const handleRefreshButtonClick = () => {
    dispatch(setDelayCodesSyncLoadingState(true));
    dispatch(setDelayCodesHasSyncStoreAsync(false));
    delayCodesSyncTimer?.fire();
  };

  return (
    <IonItem>
      <IonLabel text-wrap>
        <IonText>
          <IonLabel>{title}</IonLabel>
        </IonText>
        {(() => {
          switch (delayCodesSyncLoading) {
            case false:
              return (
                <IonText color="medium">
                  Last sync - <span>{delayCodeTimestamp} minutes</span>
                </IonText>
              );
            case true:
              return <IonText>Last sync - synchronising...</IonText>;
          }
        })()}
      </IonLabel>
      {enableOfflineMode && (
        <IonButton slot="end" color="primary" disabled={delayCodesSyncLoading} onClick={() => handleRefreshButtonClick()}>
          {(() => {
            switch (delayCodesSyncLoading) {
              case false:
                return <IonIcon icon={refresh} color="secondary" />;
              case true:
                return <IonSpinner name="lines-small" color="secondary"></IonSpinner>;
            }
          })()}
        </IonButton>
      )}
    </IonItem>
  );
};

export default DelayCodesSyncItem;
